<script>
export default {
  props: [ 'settings' ]
}
</script>

<template>
  <component :is='settings.heading'>{{ settings.text }}</component>
</template>
